import { render } from "./SectionRightImageHtml.vue?vue&type=template&id=36ccdcbc&scoped=true"
import script from "./SectionRightImageHtml.vue?vue&type=script&lang=js"
export * from "./SectionRightImageHtml.vue?vue&type=script&lang=js"

import "./SectionRightImageHtml.vue?vue&type=style&index=0&id=36ccdcbc&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36ccdcbc"]])

export default __exports__